/**
 * Ritorna l'HTML pulito dei tag, da utilizzare esclusivamente per la
 * visualizzazione lato browser.
 * Utilizza `DOMParser` per la pulizia che è disponibile solo sui browser.
 */
export function stripHtmlForDisplay(html: string): string {
  return (
    new DOMParser().parseFromString(html, 'text/html').body.textContent || ''
  );
}
